import { OFFER_SOURCE_OF_FUNDS_INDIA } from 'constants/fields';
import type { Field } from 'models/field';
import type { Section, SectionField } from 'models/section';
import type { RootState } from 'reducers/types';
import { getFieldValue } from 'selectors/ui/ui';
import {
  type SectionName,
  isSectionPrefilled,
  mergeDuplicatedSections,
  populatedFields,
} from '../sections';

export const getSectionsByEntityForIndia = (
  state: RootState,
  entity: SectionName,
) => {
  const {
    entities: {
      sections: {
        [entity]: { byId: sectionsById, ids: sectionIds },
      },
    },
  } = state;

  return sectionIds.map(id => {
    const section = { ...sectionsById[id] };

    const fields = populatedFields(state, section.fields as string[]);
    const filteredFields = filterIndiaFields(state, fields);
    const prefilled = isSectionPrefilled(filteredFields);

    return {
      ...section,
      fields: filteredFields,
      prefilled,
    } as Section<SectionField>;
  });
};

export const getSectionsByEntitiesForIndia = (
  state: RootState,
  entities: SectionName[],
) => {
  const sections = entities.reduce((accumulator, entity: SectionName) => {
    const sections = getSectionsByEntityForIndia(state, entity);
    return accumulator.concat(sections);
  }, [] as Section<SectionField>[]);

  return mergeDuplicatedSections(sections);
};

const filterIndiaFields = (state: RootState, fields: Field[]) => {
  if (getFieldValue(state, OFFER_SOURCE_OF_FUNDS_INDIA)) {
    return fields.filter(field => field.id !== OFFER_SOURCE_OF_FUNDS_INDIA);
  }
  return fields;
};
